import React from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import {routes} from "../../../../../../core/models/static/routes/app-routes";
import CreditsListView from "./list";
import CreditInformationView from "./single";
import useAccessLevels from "../../../../../hooks/use-access-levels";


const CreditViews = () => {
    const operatorAccessLevels = useAccessLevels();

    return (
        <Switch>
            {
                operatorAccessLevels.packages.sales.creditInformation &&
                <Route path={routes.customer.sales.credits.single} exact>
                    <CreditInformationView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.sales.creditsList &&
                <Route path={[
                    routes.customer.sales.credits.base,
                    routes.sales.credits,
                ]} exact>
                    <CreditsListView/>
                </Route>
            }
            <Redirect to={routes.sales.credits.concat(routes.error.serverErrorForSection)}/>
        </Switch>
    );
};

export default CreditViews;
